var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _FiltersStore_instances, _FiltersStore_availableFilters, _FiltersStore_filtersState, _FiltersStore_buildFiltersState, _FiltersStore_isValidCategoryValue, _FiltersStore_setCategoryValues;
import Emitter from '@helpers/Emitter';
import { FILTERS_STORE_EVENTS } from '@resources/js/components/filters/filterEvents';
import { isSameValues } from '@resources/js/components/filters/helpers';
class FiltersStore extends Emitter {
    constructor(availableFilters, initialState = {}) {
        super();
        _FiltersStore_instances.add(this);
        _FiltersStore_availableFilters.set(this, void 0); // усі валідні id по кожній категорії — довідник для валідації
        _FiltersStore_filtersState.set(this, void 0); // поточний обраний стан, завжди підмножина #availableFilters
        __classPrivateFieldSet(this, _FiltersStore_availableFilters, availableFilters, "f");
        __classPrivateFieldSet(this, _FiltersStore_filtersState, __classPrivateFieldGet(this, _FiltersStore_instances, "m", _FiltersStore_buildFiltersState).call(this, initialState), "f");
    }
    getData() {
        return structuredClone(__classPrivateFieldGet(this, _FiltersStore_filtersState, "f"));
    }
    toggleCategoryValue(category, value) {
        const currentValues = __classPrivateFieldGet(this, _FiltersStore_filtersState, "f")[category];
        if (!currentValues)
            return;
        const isSelected = currentValues.includes(value);
        if (!isSelected && !__classPrivateFieldGet(this, _FiltersStore_instances, "m", _FiltersStore_isValidCategoryValue).call(this, category, value))
            return;
        // toggle: якщо value вже обране — знімаємо (filter), інакше додаємо (spread)
        const nextValues = isSelected
            ? currentValues.filter(existing => existing !== value)
            : [...currentValues, value];
        __classPrivateFieldGet(this, _FiltersStore_instances, "m", _FiltersStore_setCategoryValues).call(this, category, nextValues);
    }
    setCategoryValue(category, value) {
        if (!__classPrivateFieldGet(this, _FiltersStore_instances, "m", _FiltersStore_isValidCategoryValue).call(this, category, value))
            return;
        __classPrivateFieldGet(this, _FiltersStore_instances, "m", _FiltersStore_setCategoryValues).call(this, category, [value]);
    }
    // changes може бути як діфом торкнутих категорій, так і повним станом
    applyChanges(changes) {
        const knownChanges = {};
        for (const category in changes) {
            if (!(category in __classPrivateFieldGet(this, _FiltersStore_availableFilters, "f")))
                continue;
            const values = changes[category].filter(value => __classPrivateFieldGet(this, _FiltersStore_instances, "m", _FiltersStore_isValidCategoryValue).call(this, category, value));
            // значення категорії не змінились — у зміни не потрапляє
            if (isSameValues(__classPrivateFieldGet(this, _FiltersStore_filtersState, "f")[category], values))
                continue;
            knownChanges[category] = values;
        }
        // нічого не змінилось — CHANGE не емітимо
        if (Object.keys(knownChanges).length === 0)
            return;
        __classPrivateFieldSet(this, _FiltersStore_filtersState, Object.assign(Object.assign({}, __classPrivateFieldGet(this, _FiltersStore_filtersState, "f")), knownChanges), "f");
        this.emit(FILTERS_STORE_EVENTS.CHANGE, knownChanges);
    }
    clear() {
        __classPrivateFieldSet(this, _FiltersStore_filtersState, __classPrivateFieldGet(this, _FiltersStore_instances, "m", _FiltersStore_buildFiltersState).call(this), "f");
        this.emit(FILTERS_STORE_EVENTS.CLEAR);
    }
}
_FiltersStore_availableFilters = new WeakMap(), _FiltersStore_filtersState = new WeakMap(), _FiltersStore_instances = new WeakSet(), _FiltersStore_buildFiltersState = function _FiltersStore_buildFiltersState(initialState = {}) {
    var _a;
    const filtersState = {};
    for (const category in __classPrivateFieldGet(this, _FiltersStore_availableFilters, "f")) {
        const values = (_a = initialState[category]) !== null && _a !== void 0 ? _a : [];
        filtersState[category] = values.filter(value => __classPrivateFieldGet(this, _FiltersStore_instances, "m", _FiltersStore_isValidCategoryValue).call(this, category, value));
    }
    return filtersState;
}, _FiltersStore_isValidCategoryValue = function _FiltersStore_isValidCategoryValue(category, value) {
    var _a, _b;
    return (_b = (_a = __classPrivateFieldGet(this, _FiltersStore_availableFilters, "f")[category]) === null || _a === void 0 ? void 0 : _a.includes(value)) !== null && _b !== void 0 ? _b : false;
}, _FiltersStore_setCategoryValues = function _FiltersStore_setCategoryValues(category, values) {
    __classPrivateFieldSet(this, _FiltersStore_filtersState, Object.assign(Object.assign({}, __classPrivateFieldGet(this, _FiltersStore_filtersState, "f")), { [category]: values }), "f");
    this.emit(FILTERS_STORE_EVENTS.CHANGE, { [category]: values });
};
export default FiltersStore;
